module.exports = __webpack_public_path__ + "static/img/a007.1d0adb0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a007.jpg
// module id = OC8h
// module chunks = 0